import "@components/wordpress"

import "@components/scroll-up/scroll-up"
import "@components/modal/modal"

// Items

import "@components/items/faq-item/faq-item"
import "@components/items/info-item/info-item"
